export default function ucfirst(str: string): string {
    return str.charAt(0).toUpperCase() + str.substring(1);
}
